// What the import screen tells the user when a limit of the plan stops an import.

import type {
  ImportBlockType,
  ImportRefusalType,
  ImportUsageStatusType,
} from "@/utils/serverActions/import/importActions";

const number = (value: number) => value.toLocaleString("es");

/** The rows asked for do not fit what the plan has left. */
export const usageLimitMessage = (usage: ImportUsageStatusType): string => {
  const requested = usage.requested ?? 0;
  const left = usage.remaining ?? 0;
  const limit = usage.limit ?? 0;
  const options =
    left > 0
      ? `Puedes reducir el archivo a ${number(left)} filas o menos, o pedir una ampliación a Orquesti.`
      : "Ya no te quedan filas: pide una ampliación a Orquesti.";
  return (
    `Esta importación tiene ${number(requested)} filas y a tu plan le quedan ${number(left)} ` +
    `de ${number(limit)} (ya usaste ${number(usage.used)}). ${options}`
  );
};

/** The imports of the company are blocked: why, until when, and who to talk to. */
export const importBlockedMessage = (
  block?: ImportBlockType | null,
  usesHour12 = false,
): string => {
  const until = block?.until
    ? ` hasta el ${new Date(block.until).toLocaleString("es", { dateStyle: "medium", timeStyle: "short", hour12: usesHour12 })}`
    : "";
  const reason = block?.reason ? ` Motivo: ${block.reason}` : "";
  return `Las importaciones de tu empresa están bloqueadas${until}.${reason} Escribe a Orquesti si necesitas que lo revisemos.`;
};

/** The database did not run the import. */
export const importRefusalMessage = (
  refused: ImportRefusalType,
  usage?: ImportUsageStatusType,
  block?: ImportBlockType | null,
  usesHour12 = false,
): string => {
  if (refused === "import_blocked") return importBlockedMessage(block, usesHour12);
  if (refused === "import_in_progress") {
    return "Hay otra importación en curso en tu empresa. Inténtalo de nuevo cuando termine.";
  }
  return usage
    ? usageLimitMessage(usage)
    : "Esta importación supera el límite de tu plan. Pide una ampliación a Orquesti.";
};
